import Vue from "vue";
import Router from "vue-router";
import Guard from './middleware'
import NotFound from '../views/general/NotFoundPage';
import Inicio from "../views/general/Inicio.vue";
import Login from "../views/general/Login.vue";
import DashboardLayout from "../layout/DashboardLayout";
import Entrenadores from "@/views/general/Entrenadores";

Vue.use(Router);

export default new Router({
    linkExactActiveClass: "active",
    routes: [
        {
            path: '/',
            beforeEnter: Guard.auth,
            redirect: 'dashboard',
            component: DashboardLayout,
            children: [
                {
                    path: '/dashboard',
                    name: 'Inicio',
                    component: () => import('../views/Dashboard/Dashboard.vue')
                },

            ]
        },
        {
            path: '/admin',
            beforeEnter: Guard.auth,
            redirect: 'admin',
            component: DashboardLayout,
            children: [
                {
                    path: 'jugadores',
                    name: 'Lista de Jugadores',
                    component: () => import('../views/Dashboard/Players/Players.vue')
                },
                {
                    path: 'jugadores/:baja',
                    name: 'Lista de Jugadores de baja',
                    component: () => import('../views/Dashboard/Players/Players.vue')
                },
                {
                    path: 'jugadores/:baja/pagina/:pag',
                    name: 'Lista de Jugadores de baja',
                    component: () => import('../views/Dashboard/Players/Players.vue')
                },
                {
                    path: 'jugadores/lista/:reserva',
                    name: 'Lista de reservas',
                    component: () => import('../views/Dashboard/Players/Players.vue')
                },
                {
                    path: 'jugadores/pagina/:pag',
                    name: 'Jugadores',
                    component: () => import('../views/Dashboard/Players/Players.vue')
                },
                {
                    path: 'jugadores/buscar/:searchQuery',
                    name: 'Buscar jugadores',
                    component: () => import('../views/Dashboard/Players/Players.vue')
                },
            ]
        },
        {
            path: '/jugadores',
            beforeEnter: Guard.auth,
            redirect: 'jugadores',
            component: DashboardLayout,
            children: [
                {
                    path: 'nuevo',
                    name: 'Nuevo Jugador/a',
                    component: () => import( '../views/Dashboard/Players/NewPlayer.vue')
                },
                {
                    path: ':id',
                    name: 'Jugador',
                    component: () => import( '../views/Dashboard/Players/Player.vue')
                },

            ]
        },
        {
            path: '/admin',
            beforeEnter: Guard.auth,
            redirect: 'admin',
            component: DashboardLayout,
            children: [
                {
                    path: 'presupuestos',
                    name: 'Presupuestos',
                    component: () => import('../views/Dashboard/Presupuestos/Index.vue')
                },
            ]
        },
        {
            path: '/admin',
            beforeEnter: Guard.auth,
            redirect: 'admin',
            component: DashboardLayout,
            children: [
                {
                    path: 'pagos/:sedeId/:diaId/:horaId',
                    name: 'Pagos de jugadores',
                    component: () => import('../views/Dashboard/Pagos/Pagos.vue')
                },
                {
                    path: 'pagos-general',
                    name: 'Pagos de jugadores (General)',
                    component: () => import('../views/Dashboard/Pagos/PagosGeneral.vue')
                },
            ]
        },
        {
            path: '/admin',
            beforeEnter: Guard.auth,
            redirect: 'admin',
            component: DashboardLayout,
            children: [
                {
                    path: 'servicios',
                    name: 'Servicios adicionales',
                    component: () => import('../views/Dashboard/Servicios/Index.vue')
                },
                {
                    path: 'servicios/:id',
                    name: 'Servicios adicionales',
                    component: () => import('../views/Dashboard/Servicios/Servicio.vue')
                },
            ]
        },
        {
            path: '/admin',
            beforeEnter: Guard.auth,
            redirect: 'admin',
            component: DashboardLayout,
            children: [
                {
                    path: 'correos',
                    name: 'Enviar correos',
                    component: () => import('../views/Dashboard/Correos/Index.vue')
                },
            ]
        },
        {
            path: '/admin',
            beforeEnter: Guard.auth,
            redirect: 'admin',
            component: DashboardLayout,
            children: [
                {
                    path: 'entrenadores',
                    name: 'Entrenadores',
                    component: () => import('../views/Dashboard/Entrenadores/Index.vue')
                },
            ]
        },
        {
            path: '/admin',
            beforeEnter: Guard.auth,
            redirect: 'admin',
            component: DashboardLayout,
            children: [
                {
                    path: 'balones',
                    name: 'Balones',
                    component: () => import('../views/Dashboard/Balones/Index.vue')
                },
                {
                    path: 'balones/historico',
                    name: 'Histórico balones',
                    component: () => import('../views/Dashboard/Balones/History.vue')
                },
            ]
        },
        {
            path: '/admin',
            beforeEnter: Guard.auth,
            redirect: 'admin',
            component: DashboardLayout,
            children: [
                {
                    path: 'grupos',
                    name: 'Grupos',
                    component: () => import('../views/Dashboard/Grupos/Grupos.vue')
                },
                {
                    path: 'grupos/:sede',
                    name: 'Grupos Sede',
                    component: () => import('../views/Dashboard/Grupos/GruposSede.vue')
                },
                {
                    path: 'grupos/:sede/:dia',
                    name: 'Grupos Día',
                    component: () => import('../views/Dashboard/Grupos/GruposDia.vue')
                },
                {
                    path: 'grupos/:sede/:dia/:id',
                    name: 'Grupo',
                    component: () => import( '../views/Dashboard/Grupos/Grupo.vue')
                },
                {
                    path: 'grupos/:sede/:dia/:turno/:id/crear-entrenamiento',
                    name: 'Crear entrenamiento',
                    component: () => import( '../views/Dashboard/Grupos/CrearEntrenamiento.vue')
                },
            ]
        },
        {
            path: "/inicio",
            name: "inicio",
            beforeEnter: Guard.guest,
            components: {
                default: Inicio,
            }
        },
        {
            path: "/login",
            name: "login",
            beforeEnter: Guard.guest,
            components: {
                default: Login,
            }
        },
        {
            path: "/entrenadores",
            name: "entrenadores",
            components: {
                default: Entrenadores,
            }
        },
        {
            path: '/entrenadores',
            redirect: 'entrenadores',
            component: DashboardLayout,
            children: [
                {
                    path: 'balones',
                    name: 'Registro de balones',
                    component: () => import('../views/Dashboard/Entrenadores/Balones.vue')
                },
                {
                    path: 'enviar-correo',
                    name: 'Enviar correo',
                    component: () => import('../views/Dashboard/Entrenadores/EnviarCorreo.vue')
                },
                {
                    path: 'registrar-asistencia',
                    name: 'Registrar asistencia',
                    component: () => import('../views/Dashboard/Entrenadores/RegistrarAsistencia.vue')
                }
            ]
        },
        {path: '*', component: NotFound}
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return {selector: to.hash};
        } else {
            return {x: 0, y: 0};
        }
    }
});
